import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {
  venues: [],
  currentVenue: {},
  relatedVenues: [],
  venuesLoading: false
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
